import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center px-4 text-center">
      <h2 className="text-lg font-medium text-gray-800 mb-4">Welcome to the LiveWire Product Search Database</h2>
      <motion.div
        className="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full"
        animate={{ rotate: 360 }}
        transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
      />
      <p className="mt-4 text-gray-600 font-medium">Loading products...</p>
    </div>
  );
};

export default LoadingSpinner;